import styled from "@emotion/styled";



export const CopyrightSection = styled.div`
 margin: 20px auto;
 border: solid 1px white;
 border-radius: 40px;
 padding: 2px 10px;
 display:flex;
 justify-content:space-between;
 align-items:center;


 @media (min-width: 640px) {
    width: 90%;
  }

  /* md: ≥768px */
  @media (min-width: 768px) {
    width: 80%;
  }

  /* lg: ≥1024px */
  @media (min-width: 1024px) {
    width: 70%;
  }

  /* xl: ≥1280px */
  @media (min-width: 1280px) {
    width: 50%;
  }

  /* 2xl: ≥1536px */
  @media (min-width: 1536px) {
    width: 40%;
  }



`